import React from 'react';
import { cn } from '../../lib/cn';
import { Icon, type IconKind } from '../Icon/Icon';

export interface PatientProfileTabSectionHeaderProps {
  eyebrow: string;
  title: string;
  meta?: string;
  icon?: IconKind;
  accent?: string;
  className?: string;
}

/** Section heading used across patient profile tabs (treatment plan, etc.). */
export function PatientProfileTabSectionHeader({
  eyebrow,
  title,
  meta,
  icon,
  accent = 'var(--ai-3)',
  className,
}: PatientProfileTabSectionHeaderProps) {
  return (
    <div className={cn('mb-3.5', className)}>
      <div className="mb-1.5 flex items-center gap-[7px]">
        {icon ? <Icon kind={icon} size={13} stroke={1.9} style={{ color: accent }} /> : null}
        <span className="tc-eyebrow">{eyebrow}</span>
      </div>
      <div className="flex flex-wrap items-baseline justify-between gap-3">
        <h2 className="m-0 min-w-0 flex-1 font-[var(--font-display)] text-[22px] font-semibold tracking-[-0.025em] text-[var(--ink-0)]">
          {title}
        </h2>
        {meta ? (
          <span className="tc-mono text-xs font-medium text-[var(--ink-3)]">{meta}</span>
        ) : null}
      </div>
    </div>
  );
}
